import { hasOwnProperty } from 'vessel/utils'

const items = {}

function findItem(name, callback) {
  if (hasOwnProperty(items, name)) {
    return callback(items[name])
  }
}

export default (Vue) => {
  return Vue.observable({
    active: null,
    register(name, component) {
      items[name] = component
    },
    unregister(name) {
      items[name] = null
    },
    toggle(name) {
      findItem(name, item => item.toggle())
    },
    open(name) {
      findItem(name, item => item.open())
    },
    close(name) {
      findItem(name, item => item.close())
    },
    isOpened(name) {
      return this.active === name
    },
    isClosed(name) {
      return !this.isOpened(name)
    }
  })
}
